module.exports = __webpack_public_path__ + "static/img/5.3c14b72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/preview/pengu/5.png
// module id = MnvI
// module chunks = 35